import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterDevicePage from './pages/RegisterDevicePage';
import DashboardPage from './pages/DashboardPage';
import GmailAccountsPage from './pages/GmailAccountsPage';
import TemplatesPage from './pages/TemplatesPage';
import RulesPage from './pages/RulesPage';
import NotificationsPage from './pages/NotificationsPage';
import NfsePage from './pages/NfsePage';
import CompanyPage from './pages/CompanyPage';
import Layout from './components/Layout';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registrar" element={<RegisterDevicePage />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/gmail" element={<GmailAccountsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/regras" element={<RulesPage />} />
        <Route path="/notificacoes" element={<NotificationsPage />} />
        <Route path="/nfse" element={<NfsePage />} />
        <Route path="/empresa" element={<CompanyPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
